import {createSlice} from '@reduxjs/toolkit';
import type {PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from '../store';
import {act} from 'react-test-renderer';
import {ChatMessage} from '../../types';

export interface ChatsState {
  loadingPagination: {[key: string]: boolean};
  draftMessage: {[id: string]: string | undefined};
  messages: {[key: string]: ChatMessage[]};
}

const initialState: ChatsState = {
  loadingPagination: {},
  draftMessage: {},
  messages: {},
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setPaginationState: (
      state,
      action: PayloadAction<{[key: string]: boolean}>,
    ) => {
      const key = Object.keys(action.payload)[0];
      state.loadingPagination[key] = action.payload[key];
    },

    setDraftMessage(
      state,
      {
        payload: draftMessage,
      }: PayloadAction<{id: string; content: string | undefined}>,
    ) {
      const {id, content} = draftMessage;
      state.draftMessage[id] = content;
    },

    addMessage(
      state,
      {
        payload: {chatId, message},
      }: PayloadAction<{message: ChatMessage; chatId: string}>,
    ) {
      if (!state.messages[chatId]) return;

      if (
        state.messages[chatId].some(m =>
          m._id.toString() === message._id.toString() ? m : undefined,
        )
      ) {
        return;
      }
      state.messages[chatId].unshift(message);
    },

    updateMessage(
      state,
      {
        payload: {chatId, message},
      }: PayloadAction<{message: ChatMessage; chatId: string}>,
    ) {
      state.messages[chatId].findIndex((i, index) => {
        if (i?._id === message?._id) {
          state.messages[chatId][index] = message;

          return state.messages[chatId][index];
        }

        return undefined;
      });
    },

    setMessages(
      state,
      {
        payload: {chatId, messages},
      }: PayloadAction<{messages: ChatMessage[]; chatId: string}>,
    ) {
      state.messages[chatId] = messages;
    },
  },
});

export const {setPaginationState, setDraftMessage} =
  chatSlice.actions;

export default chatSlice.reducer;
